export const UKRAINIAN = 'uk'
export const ENGLISH = 'en'
